import type { PieceLabel } from "../types/firestore/item.js"

// Get the correct label for pieces
export function labelForPiece(pieceLabel?: PieceLabel) {
  switch (pieceLabel) {
    case "piece":
      return { sing: "Stück", plur: "Stück", one: "Ein Stück" }
    case "slice":
      return { sing: "Scheibe", plur: "Scheiben", one: "Eine Scheibe" }
    case "pack":
      return { sing: "Paket", plur: "Pakete", one: "Ein Paket" }
    case "box":
      return { sing: "Kiste", plur: "Kisten", one: "Eine Kiste" }
    case "bag":
      return { sing: "Tüte", plur: "Tüten", one: "Eine Tüte" }
    case "serving":
      return { sing: "Portion", plur: "Portionen", one: "Eine Portion" }
    case "bunch":
      return { sing: "Bund", plur: "Bund", one: "Ein Bund" }
    case "bottle":
      return { sing: "Flasche", plur: "Flaschen", one: "Eine Flasche" }
    case "hand":
      return { sing: "Handvoll", plur: "Handvoll", one: "Eine Handvoll" }
    case "sac":
      return { sing: "Sack", plur: "Säcke", one: "Ein Sack" }
    case "glass":
      return { sing: "Glas", plur: "Gläser", one: "Ein Glas" }
    case "ring":
      return { sing: "Ring", plur: "Ringe", one: "Ein Ring" }
    case "bowl":
      return { sing: "Schale", plur: "Schalen", one: "Eine Schale" }
    case "basket":
      return { sing: "Korb", plur: "Körbe", one: "Ein Korb" }
    case "pouch":
      return { sing: "Beutel", plur: "Beutel", one: "Ein Beutel" }
    case "panicle":
      return { sing: "Rispe", plur: "Rispen", one: "Eine Rispe" }
    case "cluster":
      return { sing: "Traube", plur: "Trauben", one: "Eine Traube" }
    case "person":
      return { sing: "Person", plur: "Personen", one: "Eine Person" }
    default:
      return { sing: "Stück", plur: "Stücke", one: "Ein Stück" }
  }
}
